/*
  Product media: capped thumbnail rail + full-screen image gallery.

  Loaded by every product template via snippets/product-media.liquid. The rail
  shows at most five tiles — the fifth being a "+N" tile — so a product with a
  dozen photos does not stretch the page past its buy box. Everything else is
  reachable here.

  Exposes:
    window.currentSlide(index)      1-based, kept for the thumbnails' inline
                                    onclick and for older templates
    window.rrProductMedia.showSlide(index)
    window.rrProductMedia.openGallery(index0)
*/
(function () {
  function showSlide(index) {
    if (!index) return;
    var all = document.querySelectorAll('.mySlides, .myThumbSlide');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('active');
    var targets = document.querySelectorAll('.img-' + index);
    for (var j = 0; j < targets.length; j++) targets[j].classList.add('active');
  }

  function setText(selector, value) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = value == null ? '' : value;
  }

  var galleryImages = [];
  var galleryIndex = 0;
  var galleryLastFocus = null;

  function galleryEl() { return document.getElementById('RugGallery'); }

  function collectGalleryImages() {
    var thumbs = document.querySelectorAll('[data-rug-gallery-goto]');
    galleryImages = [];
    for (var i = 0; i < thumbs.length; i++) {
      galleryImages.push({
        full: thumbs[i].getAttribute('data-full'),
        alt: thumbs[i].getAttribute('data-alt') || '',
        button: thumbs[i]
      });
    }
  }

  function galleryShow(index) {
    if (!galleryImages.length) return;
    // wrap around at both ends
    galleryIndex = (index + galleryImages.length) % galleryImages.length;
    var item = galleryImages[galleryIndex];

    var img = document.querySelector('[data-rug-gallery-image]');
    if (img) {
      img.setAttribute('src', item.full);
      img.setAttribute('alt', item.alt);
    }
    setText('[data-rug-gallery-index]', String(galleryIndex + 1));

    for (var i = 0; i < galleryImages.length; i++) {
      galleryImages[i].button.classList.toggle('is-active', i === galleryIndex);
    }
    if (item.button.scrollIntoView) {
      item.button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function galleryOpen(index) {
    var el = galleryEl();
    if (!el) return;
    collectGalleryImages();
    if (!galleryImages.length) return;

    galleryLastFocus = document.activeElement;
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    document.body.classList.add('rug-gallery-open');
    galleryShow(Number(index) || 0);

    var close = el.querySelector('[data-rug-gallery-close].rug-gallery__close');
    if (close) close.focus();
  }

  function galleryClose() {
    var el = galleryEl();
    if (!el || el.hidden) return;
    el.hidden = true;
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rug-gallery-open');

    // Leave the page showing whatever the shopper ended on.
    showSlide(galleryIndex + 1);
    if (galleryLastFocus && galleryLastFocus.focus) galleryLastFocus.focus();
  }

  var galleryBound = false;

  function bindGallery() {
    if (galleryBound || !galleryEl()) return;
    galleryBound = true;

    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-rug-gallery-open]');
      if (open) {
        e.preventDefault();
        galleryOpen(open.getAttribute('data-rug-gallery-open'));
        return;
      }
      if (e.target.closest && e.target.closest('[data-rug-gallery-close]')) {
        galleryClose();
        return;
      }
      var step = e.target.closest && e.target.closest('[data-rug-gallery-step]');
      if (step) {
        galleryShow(galleryIndex + Number(step.getAttribute('data-rug-gallery-step')));
        return;
      }
      var goto = e.target.closest && e.target.closest('[data-rug-gallery-goto]');
      if (goto) {
        galleryShow(Number(goto.getAttribute('data-rug-gallery-goto')));
      }
    });

    document.addEventListener('keydown', function (e) {
      var el = galleryEl();
      if (!el || el.hidden) return;
      if (e.key === 'Escape') { galleryClose(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); galleryShow(galleryIndex - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); galleryShow(galleryIndex + 1); }
    });
  }


  window.currentSlide = showSlide;
  window.rrProductMedia = { showSlide: showSlide, openGallery: galleryOpen };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGallery);
  } else {
    bindGallery();
  }
})();
